<template>
  <v-card
    v-style:opacity="groupPriceModel && groupPriceModel.id !== 'DEVELOPER' && post[groupPriceModel.id.toLowerCase()] === false ? 0.5 : 1"
    :class="{dark: dark}"
    elevation="0"
    height="100%"
    :max-width="maxWidth"
    :min-width="minWidth"
    :width="width"
    @click="$emit('click')">
    <v-row>
      <v-col cols="12">
        <fin-post-cover :post="post" :highResolutionCover="highResolutionCover"/>
      </v-col>
    </v-row>
    <fin-post-time :dark-tags="dark" :post="post"
                   :time-color="dark ? 'var(--white)' : 'var(--cool-grey)'" spacing/>
    <v-row>
      <v-col class="pt-0" cols="12">
        <prismic-rich-text :field="post.title" class="title" v-if="post.title"/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FinPostCover from "@/components/pages/finAcademy/grid/PostCover"
import FinPostTime from "@/components/pages/finAcademy/grid/PostTime"
import {mapGetters} from "vuex"

export default {
  name: 'FinPostCard',
  components: {FinPostTime, FinPostCover},
  props: {
    /**
     *  Post object from prismic
     */
    post: {
      required: true,
      type: Object,
    },
    /**
     * Applies the dark theme variant to the component.
     */
    dark: {
      type: Boolean,
    },
    /**
     * Sets the maximum width for the component.
     */
    maxWidth: {
      type: [Number, String],
    },
    /**
     * Sets the minimum width for the component.
     */
    minWidth: {
      type: [Number, String],
    },
    /**
     * Sets the width for the component.
     */
    width: {
      type: [Number, String],
    },
    /**
     * enabled high resolution cover, jsut use ist for big cards with more with than 480px
     */
    highResolutionCover: {
      type: Boolean,
    }
  },
  computed: {
    ...mapGetters('auth', ['userId', 'groupPriceModel']),
  }
}
</script>

<style lang="scss" scoped>
.title {
  color: var(--night-blue);

}


.title {
  ::v-deep {
    h1 {
      font-size: 24px !important;
      font-family: Gilroy !important;
      font-weight: 700;
    }

    @media (min-width: 600px) {
      h1 {
        font-size: 16px;
      }
    }
  }
}

.v-card {
  background-color: transparent;
  border: 0 !important;
}

.dark .title {
  color: var(--white)
}

.title {
  ::v-deep {
    h1 {
      font-size: 18px !important;
    }
  }
}
</style>
